import { render, staticRenderFns } from "./LicList.vue?vue&type=template&id=6614c612&scoped=true&"
import script from "./LicList.vue?vue&type=script&lang=js&"
export * from "./LicList.vue?vue&type=script&lang=js&"
import style0 from "./LicList.vue?vue&type=style&index=0&id=6614c612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6614c612",
  null
  
)

export default component.exports